import React from "react";
import { Link } from "react-router-dom";
import { X, Plus, Minus, Trash2 } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function CartDrawer() {
  const { items, open, setOpen, updateQty, removeItem, subtotal } = useCart();
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex" data-testid="cart-drawer">
      <div className="flex-1 bg-black/50" onClick={() => setOpen(false)} />
      <aside className="w-full max-w-md bg-white flex flex-col border-l border-[#0a0a0a]">
        <div className="flex items-center justify-between px-6 py-5 border-b border-[#0a0a0a]">
          <div>
            <div className="rh-overline">Your selection</div>
            <h2 className="font-display font-black text-2xl mt-1">Cart ({items.length})</h2>
          </div>
          <button data-testid="close-cart-btn" onClick={() => setOpen(false)} className="p-2 hover:bg-[#f5f5f5]"><X size={20} /></button>
        </div>

        <div className="flex-1 overflow-y-auto">
          {items.length === 0 ? (
            <div className="p-10 text-center">
              <p className="text-[#4a4a4a] mb-6">Your cart is empty.</p>
              <button onClick={() => setOpen(false)} className="rh-btn-primary">Continue shopping</button>
            </div>
          ) : (
            items.map((i) => (
              <div key={i.product_id} className="flex gap-4 p-5 border-b border-[#e5e5e5]" data-testid={`cart-item-${i.product_id}`}>
                <div className="w-20 h-20 bg-[#f5f5f5] flex-shrink-0">
                  <img src={i.image} alt={i.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-mono text-[10px] uppercase tracking-widest text-[#4a4a4a]">{i.brand}</div>
                  <div className="text-sm font-semibold line-clamp-2 leading-tight">{i.name}</div>
                  <div className="flex items-center justify-between mt-3">
                    <div className="flex items-center border border-[#0a0a0a]">
                      <button data-testid={`dec-${i.product_id}`} onClick={() => updateQty(i.product_id, i.quantity - 1)} className="px-2 py-1 hover:bg-[#f5f5f5]"><Minus size={12} /></button>
                      <span className="px-3 text-sm rh-num">{i.quantity}</span>
                      <button data-testid={`inc-${i.product_id}`} onClick={() => updateQty(i.product_id, i.quantity + 1)} className="px-2 py-1 hover:bg-[#f5f5f5]"><Plus size={12} /></button>
                    </div>
                    <span className="font-display font-bold rh-num">${(i.price * i.quantity).toFixed(2)}</span>
                  </div>
                </div>
                <button data-testid={`remove-${i.product_id}`} onClick={() => removeItem(i.product_id)} className="text-[#4a4a4a] hover:text-[#ff3b30]"><Trash2 size={16} /></button>
              </div>
            ))
          )}
        </div>

        {items.length > 0 && (
          <div className="border-t border-[#0a0a0a] p-6 space-y-4">
            <div className="flex items-baseline justify-between">
              <span className="rh-overline">Subtotal</span>
              <span className="font-display font-black text-2xl rh-num" data-testid="cart-subtotal">${subtotal.toFixed(2)}</span>
            </div>
            <p className="text-xs text-[#4a4a4a]">Shipping & taxes calculated at checkout.</p>
            <Link data-testid="goto-checkout-btn" to="/checkout" onClick={() => setOpen(false)} className="rh-btn-primary w-full text-center block">
              Proceed to Checkout
            </Link>
            <Link to="/cart" onClick={() => setOpen(false)} className="block text-center text-xs uppercase tracking-widest underline">
              View full cart
            </Link>
          </div>
        )}
      </aside>
    </div>
  );
}
